<template>
  <div id="qrCode" :class="className">
    <div id='code'></div>
    <canvas v-show="text" id="canvas"></canvas>
  </div>
</template>
<script>
import QRCode from 'qrcode'
export default {
  name: 'qrcode',
  props: {
    className: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '默认值'
    },
    width: {
      type: Number,
      default: 256
    },
    height: {
      type: Number,
      default: 256
    },
    colorDark: {
      type: String,
      default: '#000'
    },
    colorLight: {
      type: String,
      default: '#fff'
    },
    margin: {
      type: Number,
      default: 4
    },
    scale: {
      type: Number,
      default: 4
    }

  },
  data() {
    return {

    }
  },
  methods: {
    // 生成二维码
    useqrcode() {
      const canvas = document.getElementById('canvas')
      const options = {
        width: this.width,
        height: this.height,
        color: {
          dark: this.colorDark, // Blue dots
          light: this.colorLight // Transparent background
        },
        margin: this.margin,
        scale: this.scale
      }
      /**
       * toCanvas(canvasElement, text, [options], [cb(error)])
       */
      QRCode.toCanvas(canvas, this.text, options, function (error) {
        if (error) console.error(error)
        console.log('QRCode success!')
      })
    }
  },
  updated() {
    console.log('updated')
    this.useqrcode()
  },
  mounted() {
    this.$nextTick(() => {
      if (this.text) {
        this.useqrcode()
      }
    })
  },
  watch: {
    text(newV, oldV) {
      // do something
      console.log(newV, oldV)
      this.useqrcode()
    }
  }
}
</script>
<style>
</style>
